var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 0.625V1.98438V4.25H17.0781V1.98438V0.625H19.7969V1.98438V4.25H25.6875V8.78125V11.5V26.9062V29.625H22.9688H3.03125H0.3125V26.9062V11.5V8.78125V4.25H6.20312V1.98438V0.625H8.92188ZM22.9688 11.5H3.03125V26.9062H22.9688V11.5ZM17.0781 20.5625H8.92188H7.5625V17.8438H8.92188H17.0781H18.4375V20.5625H17.0781Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMinus);
export default __webpack_public_path__ + "static/media/calendar-minus.3d11f1f947a12c55ebd14b7463b67f61.svg";
export { ForwardRef as ReactComponent };